import React, { useState, useEffect } from "react";
import "./Testimonial.css";
import { FaStar } from "react-icons/fa";
import { getOptimizedUrl } from "../../../../constants/globalFunction";

const TestimonialSection = ({ testimonials = [] }) => {

  //console.log("Received Testimonials in TestimonialSection:", testimonials);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  const cardsPerPage = isMobile ? 1 : 2;

  const mappedTestimonials = testimonials.map((item) => {
    const imagePath = item.profile_image
      ? item.profile_image.replace("storage/app/public/", "storage/app/public/")
      : "";
      

    //console.log(item);
    
    return {
      id: item._id,
      name: item.user_name || "Testimonial User",
      image: imagePath ? getOptimizedUrl(imagePath) : "",
      rating: parseInt(item.rating) || 5,
      feedback: item.testimonial || "",
    };
  });
  
  const totalSlides = Math.ceil(mappedTestimonials.length / cardsPerPage);

  useEffect(() => {
    if (totalSlides <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1 >= totalSlides ? 0 : prev + 1));
    }, 5000);

    return () => clearInterval(interval);
  }, [totalSlides]);

  useEffect(() => {
    setCurrentIndex(0);
  }, [cardsPerPage, mappedTestimonials.length]);

  if (mappedTestimonials.length === 0) {
    return null;
  }

  return (
    <section className="testimonial-v2">
      <div className="testimonial-v2__wrapper">
        <div className="testimonial-v2__content">
          <p className="testimonial-v2__badge">TESTIMONIALS</p>

          <h2 className="testimonial-v2__heading">
            VOICES OF OUR <br /> CUSTOMERS
          </h2>

          <p className="testimonial-v2__subtext">
            Thousands of happy customers, countless unforgettable fashion moments.
          </p>
        </div>

        <div className="testimonial-v2__slider-area">
          <div className="testimonial-v2__slider-window">
            <div
              className="testimonial-v2__track"
              style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
              {mappedTestimonials.map((item) => (
                <div
                  className="testimonial-v2__card"
                  key={item.id}
                  style={{ flex: `0 0 ${100 / cardsPerPage}%` }}
                >
                  <div className="testimonial-v2__card-inner">
                    <div className="testimonial-v2__user-row">
                      {item.image && (
                        <img
                          src={item.image}
                          alt={item.name}
                          className="testimonial-v2__avatar"
                        />
                      )}

                      <div className="testimonial-v2__user-meta">
                        <h4 className="testimonial-v2__name">{item.name}</h4>

                        <div className="testimonial-v2__stars">
                          {[...Array(5)].map((_, i) => (
                            <FaStar
                              key={i}
                              className={
                                i < item.rating
                                  ? "star-active"
                                  : "star-inactive"
                              }
                            />
                          ))}
                        </div>
                      </div>
                    </div>

                    <p className="testimonial-v2__feedback">
                      {item.feedback}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {totalSlides > 1 && (
            <div className="testimonial-v2__dots">
              {[...Array(totalSlides)].map((_, index) => (
                <span
                  key={index}
                  className={`testimonial-v2__dot ${
                    index === currentIndex ? "active" : ""
                  }`}
                  onClick={() => setCurrentIndex(index)}
                ></span>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;